import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
    return (
        <nav className="navbar">
            <div className="navbar-list">
                <Link to="/" className="logo">Holzbau Herzberg<br/><span style={{ fontSize: '1.2rem', fontWeight: 'normal' }}>Zimmerei Meisterbetrieb</span></Link>
                <ul className="nav-links">
                <li><Link to="/" className="navbar-link">HOME</Link></li>
                <li><Link to="/projekte" className="navbar-link">PROJEKTE</Link></li>
                    <li><Link to="/kontakt" className="navbar-link">KONTAKT</Link></li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;